import SystemCustomMenu from "./system-custom-menu";

export default SystemCustomMenu;
